import table from 'ngtemplate-loader!./table.tpl.html';
import rebook from './../rebook/popover';
import cancel from './../cancel/popover';
import approve from './../approve/popover';
import bulk from './../bulk/bulk';

import {
  default as MessageModal,
  template
} from './messageModal';

import { service as Reservation } from './../reservationHelper';
import "./styles";

export const moduleName = 'rezflow.dayview'
export const name = 'reservationDayview';

const FILTER = new WeakMap();

export default (MODULE) => {
  
  rebook(MODULE);
  cancel(MODULE);
  approve(MODULE);
  bulk(MODULE);
  Reservation(MODULE);

  class Dayview {

    /* @ngInject */
    constructor($scope, $rootScope, $filter, Reservation, $modal, $timeout) {
      const vm = this;
      this.$scope = $scope;
      this.$rs = $rootScope;
      this.Reservation = Reservation;
      FILTER.set(this, $filter);
      this.$timeout = $timeout;
      this.$modal = $modal;
      this.modal = undefined;
      this.selected = [];
      this.bulkStatus = undefined;
    }

    get user() {
      return this.$rs.user;
    }

    hasUnansweredSMS(id) {
      let messages = this.$rs.unrespondedMessages || [];
      if(!Array.isArray(messages)) {
        messages = [];
      }
      return messages.find(m => m._id === id);
    }

    openMessageModal() {
      this.modal = this.$modal.open({
        templateUrl: template,
        controller: MessageModal,
        controllerAs: '$ctrl',
        resolve: {
          listClass: () => this,
          selected: () => this.selected
        }
      });

      this.modal.result.then(({ res, selected }) => {
        if (selected && selected.type === 'cancellation') {
          const bookings = res;
          bookings.forEach(booking => {
            this.moveCancelled(booking);
          })
        }
      }).then(() => {
        console.log('test');
        this.deactivateBulk();
      }).catch(console.warn);
    }

    groups() {
      this.grouped = {
        cancelled: [],
        active: [],
        waiting: []
      };
      this.bookings.reduce((acc, item) => {
        var key = item.status;
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, this.grouped)
      return this.grouped;
    }

    removeRow(booking) {
      booking.removed = true;
    }

    deactivateBulk() {
      this.selectNone();
      this.activeBulk = undefined;
      this.bulkStatus = undefined;
    }

    triggerBulkActions(type) {
      if (!this.activeBulk) {
        this.activeBulk = type;
        this.bulkStatus = 'choose';
      } else {
        const all = this.bulkStatus === 'choose' || this.bulkStatus === 'none';
        if (all) {
          this.bulkStatus = 'all';
          this.selectAll();
        } else {
          this.bulkStatus = 'none';
          this.deactivateBulk();
          this.selectNone();
        }
      }
    }

    selectAll() {
      this.grouped.active.forEach((booking) => {
        this.selectBooking(booking);
      });
    }

    selectNone() {
      this.grouped.active.forEach((booking) => {
        this.unselectBooking(booking);
      });
    }

    toggleSelect(booking) {
      const i = this.isSelected(booking);
      if (i > -1) {
        this.unselectBooking(booking);
      } else {
        this.selectBooking(booking);
      }
    }

    isSelected(booking) {
      return this.selected.findIndex((book) => {
        return book._id === booking._id;
      })
    }

    selectBooking(booking) {
      if (this.isSelected(booking) < 0) {
        this.selected.push(booking);
        booking.checked = true;
      }
    }

    unselectBooking(booking) {
      const i = this.isSelected(booking)
      if (i >= 0) {
        console.log(this.selected);
        this.selected.splice(i, 1);
        booking.checked = false;
      }
    }

    moveActive(booking) {
      booking.status = 'active';
      this.grouped.active.push(angular.copy(booking));
      this.removeRow(booking);
    }

    moveWaiting(booking) {
      booking.status = 'waiting';
      this.grouped.waiting.push(angular.copy(booking));
      this.removeRow(booking);
    }

    movePending(booking) {
      booking.status = 'pending';
      this.grouped.pending.push(angular.copy(booking));
      this.removeRow(booking);
    }

    moveCancelled(booking) {
      booking.status = 'cancelled';
      this.grouped.cancelled.push(angular.copy(booking));
      this.removeRow(booking);
    }

    isPast() {
      const today = moment();
      return this.day.isSameOrBefore(today, 'days');
    }

    signatures(booking) {
      var count = 0;
      var waivers = booking.smartWaiver;
      angular.forEach(waivers, function (waiver, i) {
        var data = waiver.data;
        count += data.participants.reduce(function (prev, cur) {
          return prev + 1;
        }, 0)
      })
      return count;
    }

    isHeavy(booking) {
      return booking.meta.weights.find((w) => w >= 275) !== undefined;
    }

    $onInit() {
      this.bookings = this.bookings.map((booking) => {
        const reservation = this.Reservation;
        return reservation.fill(booking);
      });
      this.groups();
    }

  }

  angular.module(MODULE)
    .component(name, {
      bindings: {
        bookings: '<',
        day: '<'
      },
      templateUrl: table,
      controller: Dayview
    });

  return name;

};



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/dayview/list.js